import React, { useRef, useEffect, useState } from "react";
import "../../css/style.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/API_Client";
import {
  Alert,
  Button,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import "../analytics/analytics.css";
import LoadingLogoPage from "../loadingPage/loadingPage";

const SamlTokenHandler = () => {
  const {
    validateToken,
    merchantSettings,
    getAllReportType,
    getAllPspConfigs,
    getUserDetails,
    getDynamicRoute,
    defaultPageLink,
  } = useAuth();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [searchParams, setSearchParams] = useSearchParams();

  const setErrorMsg = (errMsg) => {

  };

  useEffect(() => {
    const merchantId = searchParams.get('orgId');
    const token = searchParams.get('token');
    validateToken(merchantId, token,
      () => {
        merchantSettings(() => {
          const landingPage = localStorage.getItem("currentPathname") || defaultPageLink();
          if (landingPage === undefined) {
            window.location.href = "/";
          } else {
            try {
              getDynamicRoute(landingPage).then(res => {
                navigate(res);
              })
            } catch (error) {
              navigate("/");
            }
          }
        }, setErrorMsg);
        getAllReportType();
        getAllPspConfigs();
      },
      setErrorMsg)
  }, []);

  return (
    <div>
      {showLoader && <LoadingLogoPage></LoadingLogoPage>}
    </div>
  );
};

export default SamlTokenHandler;
